import React, { Fragment } from 'react';
import { __ } from '@wordpress/i18n';
import ReactDOM from 'react-dom';

// Components.
import SafeHTML from '../safe-html';

// Services.
import getApiFetch from '../../js/services/getApiFetch';
import fetchAll from '../../js/services/fetch-all';

const appElement = document.querySelector('.topic-content-list');
const apiFetch = getApiFetch();

/**
 * Formats provided date string into more readable, American English style date.
 *
 * @param {string} datestring - Date string to format.
 */
const formatDate = (datestring) => {
  // below regexp necessary for Safari; will fail to recognize as Date object without the T
  const date = new Date(datestring.replace(/\s/g, 'T'));
  // eslint-disable-next-line max-len
  return date.toLocaleString('default', { day: 'numeric', month: 'long', year: 'numeric' });
};

class ContentList extends React.Component {
  /**
   * Constructor. Binds function scope.
   * @param {object} props - Props for this component.
   */
  constructor(props) {
    super(props);
    this.state = {
      activeTopic: {},
      loading: true,
      contentList: [],
      topicList: [],
      topicLoading: false,
    };
    this.onTopicActivate = this
      .onTopicActivate.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  onTopicActivate(topic) {
    this.setState({
      topicLoading: true,
    });
    apiFetch({
      path: `/knight-foundation/v1/posts-in-topic/${topic.id}?count=5`,
    })
      .then((data) => {
        this.setState({
          activeTopic: {
            id: topic.id,
            name: topic.name,
            slug: topic.slug,
          },
          contentList: data,
          topicLoading: false,
        });
      });
  }

  /**
   * An async function to load initial data for the app.
   */
  async loadData() {
    const { topics } = await fetchAll(['topics']);
    this.setState({
      loading: false,
      topicList: topics,
    }, () => {
      this.onTopicActivate(this.state.topicList[0]);
    });
  }

  /**
   * Renders component markup.
   * @returns {object} - JSX for this component.
   */
  render() {
    const {
      activeTopic,
      loading,
      contentList,
      topicList,
      topicLoading,
    } = this.state;

    if (! appElement) {
      return false;
    }
    return (
      <div className="content-listing">
        <h2>{__('Explore All Topics', 'knight-foundation-app')}</h2>
        {loading ? (
          <div className="content-listing__loading">
            {__('Loading...', 'knight-foundation-app')}
          </div>
        ) : (
          <div className="content-listing__panel">
            {0 < topicList.length && (
              <div className="content-listing__toolbar">
                <ul className="content-listing__toolbar-inner">
                  {topicList.map((topic) => {
                    const activeCl = topic.id === activeTopic.id
                      ? 'is-active' : '';
                    return (
                      <li key={topic.id}>
                        <SafeHTML
                          className={`content-listing__filter-item ${activeCl}`}
                          html={topic.name}
                          onClick={() => this.onTopicActivate(topic)}
                          tag="button"
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="content-listing__panel-content">
              {topicLoading ? (
                <div className="content-listing__loading">
                  {__('Loading...', 'knight-foundation-app')}
                </div>
              ) : (
                <Fragment>
                  <ul className="content-listing__content-list">
                    {contentList.map((item) => {
                      const publicationDate = formatDate(item.post_date);
                      /* eslint-enable */
                      return (
                        <li
                          className="content-listing__item"
                          key={item.ID}
                        >
                          {item.thumbnail && (
                            <div className="item__image">
                              <img
                                alt={item.post_title}
                                src={item.thumbnail}
                              />
                            </div>
                          )}
                          <div className="item__details">
                            <div className="item__type">
                              {item.post_type_name}
                            </div>
                            <a // eslint-disable-line jsx-a11y/anchor-has-content
                              className="item__cover"
                              href={item.link}
                            >
                              <div className="item__title">
                                {item.post_title}
                              </div>
                            </a>
                            {publicationDate && (
                              <div className="item__date">
                                {publicationDate}
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="content-listing__more">
                    <a href={`/topics/${activeTopic.slug}`}>
                      <button>
                        View More
                      </button>
                    </a>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

if (appElement) {
  ReactDOM.render(React.createElement(ContentList, null), appElement);
}
